<template>
  <div class="content">
    <div class="table-container">
      <b-table
        :items="$store.state.itemTable"
        :per-page="totalPerPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :fields="actualFields"
        :no-border-collapse="false"
        :tbody-tr-class="rowClass"
        :filter="$store.state.search"
        class="table-box"
        sticky-header="100vh"
        :small="small"
        striped
        :fixed="true"
        responsive
        ref="tableResponsive"
        @row-clicked="showDetail"
        @filtered="onFiltered"
      >
        <template v-slot:thead-top>
          <b-tr>
            <b-th
              colspan="4"
              class="text-center bg-head"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); border-right: 1px solid rgba(0, 0, 0, 0.12); color : #fff"
              >Vendor Code</b-th
            >
            <b-th
              v-for="index in 7"
              :key="`default-${index}`"
              class="bg-head"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.12);"
            ></b-th>
            <b-th
              v-for="index in 35"
              :key="`filtered-${index}`"
              class="bg-head"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.12);"
            ></b-th>
          </b-tr>
        </template>

        <template v-slot:table-colgroup>
          <col
            v-for="field in tableColumn()"
            :key="field.key"
            :style="{ width: widthHeadTable(field.key) }"
            :rowspan="!filteredFields.includes(field.key) ? 2 : 1"
          />
        </template>

        <template v-slot:cell(VENDOR_NAME)="item">
          <span
            :id="
              `popover-vendor-name-${item.item.id}${item.item.VENDOR_ID_ARIBA}${item.item.VENDOR_ID_SAPBC}${item.item.VENDOR_ID_SAPGEMS}${item.item.VENDOR_ID_SAPBKES}`
            "
            >{{ maxWord(item.value) }}</span
          >
          <b-popover
            :target="
              `popover-vendor-name-${item.item.id}${item.item.VENDOR_ID_ARIBA}${item.item.VENDOR_ID_SAPBC}${item.item.VENDOR_ID_SAPGEMS}${item.item.VENDOR_ID_SAPBKES}`
            "
            triggers="hover focus"
            placement="leftbottom"
          >
            <template v-slot:title>{{ item.item.VENDOR_NAME }}</template>
            <span>Status : {{ item.item.STATUS_SUPPLIER }}</span
            ><br />
          </b-popover>
        </template>

        <template v-slot:cell(ORGANIZATION)="item">
          <span>{{ item.value }}</span>
        </template>

        <!-- Total PO Value -->
        <template v-slot:cell(TOTAL_PO_RELEASED)="item">
          <div class="row-with-button">
            <span>{{ item.value }}</span>
            <b-button
              v-if="$store.state.currentUser"
              class="button-detail"
              @click="buttonDetailTab('po_released', item.item)"
            >
              <i class="material-icons">dehaze</i>
            </b-button>
          </div>
        </template>
        <!-- Legal Document -->
        <template v-slot:cell(LEGAL_DOCUMENT)="item">
          <div class="row-with-button">
            <span
              :id="
                `popover-legal-doc-${item.item.id}${item.item.VENDOR_ID_ARIBA}${item.item.VENDOR_ID_SAPBC}${item.item.VENDOR_ID_SAPGEMS}${item.item.VENDOR_ID_SAPBKES}`
              "
              v-if="item.value && item.value.toUpperCase() === 'YES'"
              :style="
                `color : ${expiredIndicator(
                  item.item.LEGAL_DOCUMENT_EXPIRED_DATE
                )}`
              "
            >
              <i class="material-icons">fiber_manual_record</i>
            </span>
            <span
              :id="
                `popover-legal-doc-${item.item.id}${item.item.VENDOR_ID_ARIBA}${item.item.VENDOR_ID_SAPBC}${item.item.VENDOR_ID_SAPGEMS}${item.item.VENDOR_ID_SAPBKES}`
              "
              style="color: #d63031"
              v-else
            >
              <i class="material-icons">fiber_manual_record</i>
            </span>
            <b-button
              class="button-detail"
              @click="buttonDetailTab('legal_documents', item.item)"
            >
              <i class="material-icons">dehaze</i>
            </b-button>
          </div>
          <b-popover
            :target="
              `popover-legal-doc-${item.item.id}${item.item.VENDOR_ID_ARIBA}${item.item.VENDOR_ID_SAPBC}${item.item.VENDOR_ID_SAPGEMS}${item.item.VENDOR_ID_SAPBKES}`
            "
            triggers="hover focus"
            placement="leftbottom"
          >
            <template v-slot:title>{{ item.item.VENDOR_NAME }}</template>
            <span>{{
              item.value.toUpperCase() === 'YES'
                ? 'Complete Document'
                : 'Not Complete Document'
            }}</span
            ><br />
            <span
              >Expired Doc :
              {{
                legalDocumentCheckDate(item.item.LEGAL_DOCUMENT_EXPIRED_DATE)
              }}</span
            >
          </b-popover>
        </template>

        <template v-slot:cell(SCORE_FOR_K3L_PREQUALIFICATION)="item">
          <div class="row-with-button">
            <span
              :id="
                `popover-k3l-assesment-${item.item.id}${item.item.VENDOR_ID_ARIBA}${item.item.VENDOR_ID_SAPBC}${item.item.VENDOR_ID_SAPGEMS}${item.item.VENDOR_ID_SAPBKES}`
              "
              >{{ item.value ? Number(item.value).toFixed(0) : '-' }}</span
            >
            <b-button
              class="button-detail"
              @click="buttonDetailTab('k3l_assessment', item.item)"
            >
              <i class="material-icons">dehaze</i>
            </b-button>
          </div>
          <b-popover
            :target="
              `popover-k3l-assesment-${item.item.id}${item.item.VENDOR_ID_ARIBA}${item.item.VENDOR_ID_SAPBC}${item.item.VENDOR_ID_SAPGEMS}${item.item.VENDOR_ID_SAPBKES}`
            "
            triggers="hover focus"
            placement="leftbottom"
          >
            <template v-slot:title>{{ item.item.VENDOR_NAME }}</template>
            Risk Category :
            {{ k3lRiskCategory(item.item.SCORE_FOR_K3L_PREQUALIFICATION) }}
          </b-popover>
        </template>

        <template v-slot:cell(RISK_CATEGORY)="data">
          <span>{{
            k3lRiskCategory(data.item.SCORE_FOR_K3L_PREQUALIFICATION)
          }}</span>
        </template>

        <template v-slot:cell(APPROVED_COMMODITIES)="item">
          <span
            :id="
              `popover-commodities-${item.item.id}${item.item.VENDOR_ID_ARIBA}${item.item.VENDOR_ID_SAPBC}${item.item.VENDOR_ID_SAPGEMS}${item.item.VENDOR_ID_SAPBKES}`
            "
            >{{ maxWord(item.value) }}</span
          >
          <b-popover
            :target="
              `popover-commodities-${item.item.id}${item.item.VENDOR_ID_ARIBA}${item.item.VENDOR_ID_SAPBC}${item.item.VENDOR_ID_SAPGEMS}${item.item.VENDOR_ID_SAPBKES}`
            "
            triggers="hover focus"
            placement="bottom"
          >
            <template v-slot:title>{{ item.item.VENDOR_NAME }}</template>
            <span>Commodities : {{ item.value }}</span
            ><br />
            <span></span>
          </b-popover>
        </template>

        <template v-slot:cell(TOTAL_EVENT)="item">
          <div class="row-with-button">
            <span
              :id="
                `popover-total-event-${item.item.id}${item.item.VENDOR_ID_ARIBA}${item.item.VENDOR_ID_SAPBC}${item.item.VENDOR_ID_SAPGEMS}${item.item.VENDOR_ID_SAPBKES}`
              "
              >{{ item.value }}</span
            >
            <b-button
              class="button-detail"
              @click="buttonDetailTab('total_event', item.item)"
            >
              <i class="material-icons">dehaze</i>
            </b-button>
          </div>
          <b-popover
            :target="
              `popover-total-event-${item.item.id}${item.item.VENDOR_ID_ARIBA}${item.item.VENDOR_ID_SAPBC}${item.item.VENDOR_ID_SAPGEMS}${item.item.VENDOR_ID_SAPBKES}`
            "
            triggers="hover focus"
            placement="leftbottom"
          >
            <template v-slot:title>{{ item.item.VENDOR_NAME }}</template>
            <span
              >Total Participated :
              {{ eventParticipated(item.item.EVENT) }}</span
            ><br />
            <span>Total Awarded : {{ eventAwarded(item.item.EVENT) }}</span>
          </b-popover>
        </template>

        <template v-slot:cell(K3L_PREQ_END_DATE)="item">
          <span>{{
            item.item.K3L_PREQ_END_DATE
              ? new Date(item.item.K3L_PREQ_END_DATE).toLocaleString(
                  'en-GB',
                  dateFormat
                )
              : '-'
          }}</span>
        </template>

        <template v-slot:cell(VENDOR_CATEGORY)="item">
          <span>{{ item.value }}</span>
        </template>

        <template v-slot:cell(K3L_REMAINING_DAYS)="item">
          <span
            :id="`popover-k3l-assesment-${item.item.id}-k3l-remaining-days`"
            >{{ item.value }}</span
          >
          <b-popover
            :target="`popover-k3l-assesment-${item.item.id}-k3l-remaining-days`"
            triggers="hover focus"
            placement="leftbottom"
          >
            <template v-slot:title>{{ item.item.VENDOR_NAME }}</template>
            <span
              >Expired Date :
              {{
                new Date(item.item.K3L_PREQ_END_DATE).toLocaleString(
                  'en-GB',
                  dateFormat
                )
              }}</span
            >
          </b-popover>
        </template>

        <template v-slot:cell(SPM_SCORING)="item">
          <div class="row-with-button">
            <span :id="`popover-k3l-assesment-${item.item.id}-spm-scoring`">{{
              spmScoring(item.item.SPM)
            }}</span>
            <b-button
              class="button-detail"
              @click="buttonDetailTab('spm_scoring', item.item)"
            >
              <i class="material-icons">dehaze</i>
            </b-button>
          </div>
          <b-popover
            :target="`popover-k3l-assesment-${item.item.id}-spm-scoring`"
            triggers="hover focus"
            placement="leftbottom"
          >
            <template v-slot:title>{{ item.item.VENDOR_NAME }}</template>
            <span>Total Average Score : {{ spmScoring(item.item.SPM) }}</span
            ><br />
            <span
              >No Of Project : {{ spmScoringTotalProject(item.item.SPM) }}</span
            >
          </b-popover>
        </template>

        <template v-slot:cell(CSI_SCORING)="item">
          <div class="row-with-button">
            <span :id="`popover-k3l-assesment-${item.item.id}-csi-scoring`">{{
              item.value
            }}</span>
            <b-button
              v-if="$store.state.currentUser"
              class="button-detail"
              @click="buttonDetailTab('csi_scoring', item.item)"
            >
              <i class="material-icons">dehaze</i>
            </b-button>
          </div>
          <b-popover
            :target="`popover-k3l-assesment-${item.item.id}-csi-scoring`"
            triggers="hover focus"
            placement="leftbottom"
          >
            <template v-slot:title>{{ item.item.VENDOR_NAME }}</template>
            <span>Final Adj : {{ csiFinalAdj(item.item.csi) }}</span>
          </b-popover>
        </template>

        <template v-slot:cell(PO_VALUE)="item">
          <div class="po-value-idr">
            <span>{{ totalValue(item.value) }}</span>
          </div>
        </template>

        <template v-slot:cell(ADDRESS)="data">
          <span>{{ maxWord(data.value) }}</span>
        </template>

        <template v-slot:cell(CITY)="data">
          <span>{{ maxWord(data.value) }}</span>
        </template>

        <template v-slot:cell(PROVINCE)="data">
          <span>{{ maxWord(data.value) }}</span>
        </template>

        <template v-slot:cell(COUNTRY)="data">
          <span>{{ maxWord(data.value) }}</span>
        </template>

        <template v-slot:cell(LEGAL_DOCUMENT_EXPIRED)="data">
          <span>{{
            data.value
              ? data.value.toUpperCase() == 'YES'
                ? 'Expired'
                : 'Active'
              : '-'
          }}</span>
        </template>

        <template v-slot:cell(LEGAL_DOCUMENT_EXPIRED_DATE)="data">
          <span>{{ legalDocumentCheckDate(data.value) }}</span>
        </template>

        <template v-slot:cell(SIO)="data">
          <span>{{ data.item.SIO_NUMBER ? 'Yes' : 'No' }}</span>
        </template>
      </b-table>
    </div>
    <div class="datatable-pagination-setting">
      <div class="rows-setting">
        <p class="title-setting">Total Rows :</p>
        <b-form-select
          v-model="totalPerPage"
          :options="modes"
          class="select"
        ></b-form-select>
      </div>
      <b-pagination
        aria-controls="isupplier-table"
        v-model="currentPage"
        :total-rows="$store.state.itemTable.length"
        :per-page="totalPerPage"
        align="fill"
        class="my-0 page-button"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import numeral from 'numeral'
export default {
  name: 'DataTable',
  data() {
    return {
      currentPage: 1,
      totalPerPage: 25,
      modes: [5, 10, 15, 25],
      small: false,
      totalRows: null,
      dateFormat: { day: 'numeric', month: 'short', year: 'numeric' },
      sortBy: 'vendor_code',
      sortDesc: false,
      selected: null,
      navigationItems: null,
    }
  },
  computed: {
    filteredFields() {
      const fieldsToFilter = [
        'VENDOR_ID_ARIBA',
        'VENDOR_ID_SAPBC',
        'VENDOR_ID_SAPGEMS',
        'VENDOR_ID_SAPBKES',
      ]
      return this.tableColumn().filter(
        item => !fieldsToFilter.includes(item.key)
      )
    },
    actualFields: function() {
      const self = this
      const currentRole = self.$store.state.currentUser
        ? self.$store.state.currentUser.role
        : 'custodian'
      let fields = self.tableColumn()
      if (self.$store.state.currentUser) {
        return fields
      }
      return fields
    },
  },
  methods: {
    maxWord(word) {
      if (word) {
        if (word.length > 20) {
          return `${word.substring(20, 0)} ...`
        }
        return word
      }
      return null
    },
    tableColumn() {
      const self = this
      if (self.$store.state.datatable.tableFields) {
        return self.$store.state.datatable.tableFields
      }
    },
    onFiltered(filteredItems) {
      const self = this
      return self.$store.state.itemTable
    },
    legalDocumentCheckDate(value) {
      if (value && moment(value).isValid()) {
        return moment(value).format('DD MMM YYYY')
      }
      return '-'
    },
    k3lRiskCategory(score) {
      if (score && score > 0) {
        if (score <= 24) return 'LOW C2'
        if (score > 24 && score < 35) return 'LOW C1'
        if (score >= 35 && score < 50) return 'MEDIUM B2'
        if (score >= 50 && score < 70) return 'MEDIUM B1'
        if (score >= 70 && score <= 100) return 'HIGH'
      }
      return '-'
    },
    csiFinalAdj(data) {
      if (data && data.length > 0) {
        if (Math.round(this.calCsi(data)) <= 1) return 'CSI Sangat Buruk'
        if (Math.round(this.calCsi(data)) == 2) return 'CSI Tidak Memuaskan'
        if (Math.round(this.calCsi(data)) == 3) return 'CSI Cukup Memuaskan'
        if (Math.round(this.calCsi(data)) == 4) return 'CSI Memuaskan'
        if (Math.round(this.calCsi(data)) == 5) return 'CSI Sangat Memuaskan'
      }
      return '-'
    },

    async showDetail(items) {
      try {
        const self = this
        self.selected = items
        await self.$store.dispatch('datatable/setDetail', self.selected)
        await self.$bvModal.show('detail-modal')
      } catch (error) {}
    },
    rowClass(item, type) {
      if (item.STATUS_SUPPLIER == 'Block') {
        return 'bg-secondary'
      }
      return
    },
    expiredIndicator(items) {
      if (items && moment(items).isValid()) {
        const self = this
        const documentExpire =
          (new Date(items).getTime() - new Date().getTime()) /
          (1000 * 60 * 60 * 24)
        if (self.$store.state.currentUser) {
          if (
            documentExpire >= 0 &&
            documentExpire <= 60 &&
            self.$store.state.currentUser.role == 'SIPM'
          ) {
            return '#32ff7e'
          }
        }
        if (documentExpire < 0) {
          return '#ffeaa7'
        }
      }
      return 'green'
    },
    buttonDetailTab(tab, data) {
      const self = this
      self.$store.dispatch('setCurrentTab', tab)
      self.showDetail(data)
    },
    widthHeadTable(field) {
      switch (field) {
        case 'VENDOR_ID_ARIBA':
          return '100px'
        case 'VENDOR_ID_SAPBC':
          return '100px'
        case 'VENDOR_ID_SAPGEMS':
          return '100px'
        case 'VENDOR_ID_SAPBKES':
          return '100px'
        case 'VENDOR_NAME':
          return '140px'
        case 'APPROVED_COMMODITIES':
          return '150px'
        case 'ORGANIZATION':
          return '100px'
        case 'TOTAL_PO_RELEASED':
          return '100px'
        case 'LEGAL_DOCUMENT':
          return '100px'
        case 'TOTAL_EVENT':
          return '100px'
        case 'SCORE_FOR_K3L_PREQUALIFICATION':
          return '100px'
        case 'RISK_CATEGORY':
          return '100px'
        case 'K3L_PREQ_END_DATE':
          return '120px'
        case 'K3L_REMAINING_DAYS':
          return '100px'
        case 'SPM_SCORING':
          return '100px'
        case 'SPM_TOTAL_AVG_SCORE':
          return '100px'
        case 'SPM_PERFORMANCE_PERIOD':
          return '100px'
        case 'VENDOR_CATEGORY':
          return '100px'
        case 'CSI_SCORING':
          return '100px'
        case 'CSI_FINAL_ADJ':
          return '100px'
        case 'ADDRESS':
          return '150px'
        case 'LEGAL_DOCUMENT_EXPIRED':
          return '100px'
        case 'LEGAL_DOCUMENT_EXPIRED_DATE':
          return '100px'
        case 'TKDN':
          return '100px'
        case 'HASIL_FINANSIAL_ASSESSMENT':
          return '100px'
        case 'STATUS_SUPPLIER':
          return '100px'
        case 'TOTAL_PO_RELEASED':
          return '100px'
        case 'PO_VALUE':
          return '150px'
        case 'EVENT_AWARDED':
          return '100px'
        case 'EVENT_PARTICIPATED':
          return '100px'
        case 'PO_TYPE':
          return '100px'
        case 'BIDANG_USAHA':
          return '100px'
        case 'CITY':
          return '100px'
        case 'PROVINCE':
          return '100px'
        case 'COUNTRY':
          return '100px'
        case 'PO_DATE':
          return '100px'
        case 'IUJP':
          return '100px'
        default:
          return '180px'
      }
    },
    eventParticipated(event) {
      if (event && event.length > 0) {
        const participate =
          event && event.filter(item => item.EVENT_PARTICIPATED > 0)
        return participate.length
      }
      return 0
    },
    eventAwarded(event) {
      if (event && event.length > 0) {
        const participate =
          event && event.filter(item => item.EVENT_AWARDED > 0)
        return participate.length
      }
      return 0
    },
    calCsi(value) {
      let count = 0
      let item = 0
      value &&
        value.map(list => {
          if (list.CSI_SCORE_AVG && typeof Number) {
            count += parseInt(list.CSI_SCORE_AVG)
            item++
          }
        })

      if (item > 0) {
        return Math.round(count / item)
      }
      return '-'
    },
    vendorCategory(score) {
      if (this.spmScoring(score) >= 95) {
        return 'Sangat Memuaskan'
      } else if (this.spmScoring(score) >= 80 && this.spmScoring(score) < 95) {
        return 'Memuaskan'
      } else if (this.spmScoring(score) >= 70 && this.spmScoring(score) < 80) {
        return 'Cukup Memuaskan'
      } else if (this.spmScoring(score) > 50 && this.spmScoring(score) < 70) {
        return 'Tidak Memuaskan'
      } else if (this.spmScoring(score) >= 0 && this.spmScoring(score) <= 50) {
        return 'Sangat Buruk'
      }
    },
    spmScoring(value) {
      if (value && value.length > 0) {
        let obj = {}
        let count = 0
        let total = 0

        value.map(item => {
          if (obj[item.PROJECT_NAME] === undefined) {
            obj[item.PROJECT_NAME] = {
              avg:
                item.AVG_GRADE !== null && item.AVG_GRADE > 0
                  ? [item.AVG_GRADE]
                  : [],
            }
          } else {
            obj[item.PROJECT_NAME]['avg'] =
              item.AVG_GRADE !== null && item.AVG_GRADE > 0
                ? [...obj[item.PROJECT_NAME]['avg'], item.AVG_GRADE]
                : obj[item.PROJECT_NAME]['avg']
          }
        })

        let newObj = Object.values(obj)
        newObj &&
          newObj.map(item => {
            count +=
              item.avg.reduce((a, b) => Number(a) + Number(b), 0) /
              item.avg.length
            total++
          })

        if (total > 0) return Math.round(count / total)
      }
      return '-'
    },
    spmScoringTotalProject(value) {
      if (value && value.length > 0) {
        const unique = [...new Set(value.map(item => item.PROJECT_NAME))]
        return unique.length
      }
      return '-'
    },
    totalValue(count) {
      if (parseInt(count) > 0) {
        let idr = numeral(parseInt(count)).format('0,0.00')
        let newIdr = ''
        idr.split('').map(list => {
          if (list == ',') {
            newIdr += '.'
          } else if (list == '.') {
            newIdr += ','
          } else {
            newIdr += list
          }
        })
        return newIdr
        // }
      }
      return 0
    },
    getPoType(value) {
      let data = []
      if (value) {
        value.map(list => {
          data.push(list.PO_TYPE)
        })
        return this.removeDuplicates(data)
      }
      return '-'
    },
    removeDuplicates(array) {
      const data = array.filter((a, b) => array.indexOf(a) === b)
      let newData = ''
      if (data && data.length > 0) {
        for (let i in data) {
          if (i == 0) {
            newData += data[i]
          } else {
            newData += `, ${data[i]}`
          }
        }
        return newData
      }
      return '-'
    },
  },
}
</script>

<style lang="scss">
@import '~/assets/scss/components/datatable.scss';
</style>
